import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Skeleton } from "@/components/ui/skeleton";
import { StatusChip } from "@/components/StatusChip";
import { api, fmtUSD, fmtDate } from "@/lib/api";

export const ReceiptDialog = ({ expenseId, open, onClose, onOpenDetails }) => {
  const [exp, setExp] = useState(null);

  useEffect(() => {
    if (!open || !expenseId) return;
    setExp(null);
    api.get(`/expenses/${expenseId}`).then((r) => setExp(r.data)).catch(() => {});
  }, [open, expenseId]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md border-[#222] bg-[#141414] text-white" data-testid="receipt-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[15px]">
            Receipt
            {exp && <span className="text-[12px] font-normal text-[#6b6b6b]">· {exp.merchant} · {fmtDate(exp.date)}</span>}
          </DialogTitle>
        </DialogHeader>
        {!exp ? (
          <Skeleton className="h-72 w-full rounded-xl bg-[#1a1a1a]" />
        ) : exp.receipt_image ? (
          <div className="space-y-3">
            <div className="max-h-[60vh] overflow-y-auto rounded-xl border border-[#242424] bg-[#0d0d0d] p-2">
              <img src={exp.receipt_image} alt={`${exp.merchant} receipt`} data-testid="receipt-dialog-image"
                className="w-full rounded-lg" />
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="text-[14px] font-semibold tabular-nums">{fmtUSD(exp.amount)}</span>
                <StatusChip status={exp.status} />
              </div>
              <button onClick={() => { onClose(); onOpenDetails?.(exp.id); }} data-testid="receipt-dialog-details"
                className="text-[12px] text-[#7FAEF9] hover:text-white hover:underline">
                Open full details →
              </button>
            </div>
          </div>
        ) : (
          <div className="rounded-xl border border-dashed border-[#2a2a2a] px-4 py-10 text-center text-[12.5px] text-[#6b6b6b]">
            No receipt on file for this expense.
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
